<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Financial Forecast",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Financial Forecast",
      items: [
        {
          text: "Home",
        },
         {
          text: "Forecast",
        },
        {
          text: "Financial Forecast",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>